import React, { FC, useEffect, useMemo, useState } from "react";
import { TeamID } from "../../scripts/models/common";
import { Snapshot, SnapshotsToLoad } from "../../scripts/dataSources/snapshots";
import { CustomRatings, Ratings } from "../../scripts/models/ratings";
import ModeSelector from "../common/modeSelector/ModeSelector";
import TeamSelector from "../common/teamSelector/TeamSelector";
import { DataContext } from "../context/dataLoader/DataLoader";
import { ScatterPlot } from "./ScatterPlot";

import './TeamScatterPlot.scss';

const ALL_MODES = ["Offense and Defense", "Vibes by Role", "Offense and Defense (without Cursed players)"] as const;
type mode = (typeof ALL_MODES)[number];


// Ratings to use


export const TeamScatterPlots: FC = () => {

    useEffect(() => {
        //alert("Watch out! Chartographer's player data is currently out-of-date. New players are missing and stats aren't updated. Okay?")
    }, [])


    const data = React.useContext(DataContext)

    const [emphasizedTeam, setEmphasizedTeam] = useState<TeamID>();
    const [currentMode, setCurrentMode] = useState<mode>("Offense and Defense")

    const snapMap = useMemo(() => {
        let map: Record<string, Snapshot | undefined> = {};
        SnapshotsToLoad.forEach((snapshot) => {
            map[snapshot.name] = snapshot;
        });
        map["Current data"] = undefined;
        return map;
    }, [])

    const snapOptions = useMemo(() => {
        return SnapshotsToLoad.map(snap => snap.name).concat("Current data")
    }, [])

    const [currentSnapName, setCurrentSnapName] = useState<string>("Current data")

    const currentSnapshot = snapMap[currentSnapName];

    function getPlots() {
        switch (currentMode) {
            case "Offense and Defense": {
                const modeStr = "Avg stars per player"
                return <>
                    <ScatterPlot emphasizedTeam={emphasizedTeam} teamSet={data.teamCollections?.allTeams} titleText={`Offensive stats (${modeStr})`}
                        xAxisCategory={Ratings.Batting} yAxisCategory={Ratings.Running} snapshot={currentSnapshot} />
                    <ScatterPlot emphasizedTeam={emphasizedTeam} teamSet={data.teamCollections?.allTeams} titleText={`Defensive stats (${modeStr})`}
                        xAxisCategory={Ratings.Pitching} yAxisCategory={Ratings.Defense} snapshot={currentSnapshot} />
                </>
            }
            case "Offense and Defense (without Cursed players)": {
                const modeStr = "Avg stars per player"
                return <>
                    <ScatterPlot emphasizedTeam={emphasizedTeam} teamSet={data.teamCollections?.allTeams} titleText={`Offensive stats (${modeStr})`}
                        xAxisCategory={Ratings.Batting} yAxisCategory={Ratings.Running} snapshot={currentSnapshot} excludedMods={["Can't Lose"]} />
                    <ScatterPlot emphasizedTeam={emphasizedTeam} teamSet={data.teamCollections?.allTeams} titleText={`Defensive stats (${modeStr})`}
                        xAxisCategory={Ratings.Pitching} yAxisCategory={Ratings.Defense} snapshot={currentSnapshot} excludedMods={["Can't Lose"]} />
                </>
            }
            case "Vibes by Role": {
                return <ScatterPlot emphasizedTeam={emphasizedTeam} teamSet={data.teamCollections?.allTeams} titleText={`Vibes by player role`}
                    xAxisCategory={CustomRatings.LineupVibes} yAxisCategory={CustomRatings.RotationVibes} snapshot={currentSnapshot} />
            }

        }
    }

    return <div className="Page Scatterplots">
        <div className="modeSelector">
            <ModeSelector currentSelection={currentMode} setter={setCurrentMode} options={ALL_MODES} />
            {
                data.snapshots && <ModeSelector currentSelection={currentSnapName} setter={setCurrentSnapName} options={snapOptions} />
            }
        </div>
        <div className="plotsContainer">
            {getPlots()}
        </div>
        <div className="teamSelector">
            <TeamSelector teams={data.teamCollections?.allTeams} currentTeam={emphasizedTeam} setter={setEmphasizedTeam} triggerMethod="Hover" displayMode="Horizontal" />
        </div>
    </div>
}
